import { MesgFilter, MesgFilterInfo } from '@dinosband/bv-main-schema/dist/types'
import { UnreadCount, UnreadNotiCount, UnreadNotiCount_Empty } from '@dinosband/bv-messenger-schema'

import { DbFormValues } from '@dinosband/dbi-utils'
import * as preferences from './preferences-store'
import * as secure from './secure-store'

// NOTE: optional type으로 정의하지 말고, 항상 값을 가지도록 한다.
type BvSettings = {
  userId: number
  badge: number
  unreadCounts: Record<number, UnreadCount>
  unreadNotiCount: UnreadNotiCount
  lastMessageId: number
  lastSysNotiId: number
  messageFilters: Record<number, MesgFilter> // { [chatRoomId]: MesgFilter }
  chatRoomIsFiltered: Record<number, boolean> // { [chatRoomId]: isFiltered }
  mesgFilterInfo: Record<string, MesgFilterInfo> // { [key]: MesgFilterInfo }, key is chatRoomId or unique string. ex) 10, channel_23:1
  expertListFilter: Record<string, DbFormValues>
  authToken: string
  development: boolean
  skipIntro: boolean

  ackVersion: string
  preVersion: string
  nextVersion: string
  signOnCount: number
  signOnBlock: number

  sysInfo: string
  userGraph: string
  userGraphVersion: number
  categories: string
  userUsage: string
  tooManyNotisAck: number
  referrerId: number
  uuid: string
  logFirstRun: boolean
  checkedInitialDeepLink: boolean // 앱 시작시 딥링크 확인 여부

  joinChannelAck: boolean
  thumbnails: string
  pluginDataEnc: string
  chatRoomSearchHistory: string[]
  fullViewMode: boolean
  blockedChannelIds: string
  lastChannelId: number
  appReviewAt: string
  appReviewVersion: string
  appReviewCount: number
  hideSlotDashboardPerChannel: Record<number, boolean>
  hideSlotContentsPerChannel: Record<number, boolean>
  latestChatRoomIds: Record<number, number | string> // channelId:chatRoomId
  welcomeInfo: Record<number, Record<string, unknown> | undefined> // channelId:chatRoomId
  previewChatRoom: string
  previewExpertList: string
  dictionary: string

  [key: string]: unknown
}

const _bvSettings: BvSettings = {
  userId: 0,
  badge: 0,
  unreadCounts: {},
  unreadNotiCount: UnreadNotiCount_Empty,
  lastMessageId: 0,
  lastSysNotiId: 0,
  messageFilters: {},
  chatRoomIsFiltered: {},
  mesgFilterInfo: {},
  expertListFilter: {},
  authToken: '',
  development: false,
  skipIntro: true,

  ackVersion: '',
  preVersion: '',
  nextVersion: '',
  signOnCount: 0,
  signOnBlock: 0,

  sysInfo: '',
  userGraph: '',
  userGraphVersion: 0,
  categories: '',
  userUsage: '',
  tooManyNotisAck: 0,
  referrerId: 0,
  uuid: '',
  logFirstRun: false,
  checkedInitialDeepLink: false,

  joinChannelAck: false,
  thumbnails: '',
  pluginDataEnc: '',
  chatRoomSearchHistory: [],
  fullViewMode: false,
  blockedChannelIds: '',
  lastChannelId: 0,
  appReviewAt: '',
  appReviewVersion: '',
  appReviewCount: 0,
  hideSlotDashboardPerChannel: {},
  hideSlotContentsPerChannel: {},
  latestChatRoomIds: {},
  welcomeInfo: {},
  previewChatRoom: '',
  previewExpertList: '',
  dictionary: '[]',
}

const secureKeys = [
  'authToken',
  'development',
]

const bvSettings = new Proxy(_bvSettings, {
  set: function (target: BvSettings, key: string, value: unknown) {
    target[key] = value
    const store = secureKeys.includes(key) ? secure : preferences
    store.set(key, value).then(() => {
    }).catch((e: unknown) => {
      console.error('settings.set:', key, value, e)
    })
    return true
  },
  get: function (target: BvSettings, key: string) {
    const value = target[key]
    return value
  },
})

export default bvSettings as BvSettings

export async function initializeSettings () {
  await preferences.initPreferences()

  // read initial values from preferences store
  const keys = await preferences.keys()
  for (const key of keys) {
    const value = await preferences.get(key, typeof _bvSettings[key])
    if (value !== undefined) {
      _bvSettings[key] = value
    }
  }

  // read initial values from secure store
  for (const key of secureKeys) {
    const value = await secure.get(key, typeof _bvSettings[key])
    if (value !== undefined) {
      _bvSettings[key] = value
    }
  }
}
